import React, { ReactNode, useState } from 'react';

import { Button, HStack, VStack } from '@rbilabs/universal-components';

import { Typography } from 'components/ui';

export interface IHiddenSection {
  title: string;
  content?: ReactNode | null;
}
export const HiddenSection = ({ title, content }: IHiddenSection) => {
  const [visible, setVisible] = useState(false);

  return (
    <VStack pb={'$2'} width="full">
      <HStack justifyContent="space-between" alignItems="center">
        <Typography pt="$4" variant="headerThree">
          {title}
        </Typography>
        <Button onPress={() => setVisible(v => !v)} size={'md'} variant="ghost">
          {visible ? 'Hide Section' : 'Show Section'}
        </Button>
      </HStack>
      {visible ? content : null}
    </VStack>
  );
};
